/*
  Switch.jsx

  Custom switch, similar to MUI switch.
*/

// Npm.
import React, { useMemo } from 'react';

// Makes.
import { makeStyles, cx } from '../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    position: 'relative',
    verticalAlign: 'middle',
    userSelect: 'none',
    overflow: 'hidden',
    '& > input': {
      position: 'absolute',
      opacity: 0,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0,
      zIndex: 1,
      cursor: 'pointer',
      '&:checked ~ .dot': {
        left: '22px',
        backgroundColor: theme.color_primary_main,
      },
      '&:focus-visible ~ .slider': {
        boxShadow: `0 0 0 2px ${theme.color_primary_main} inset`,
      },
      '&:disabled': {
        cursor: 'inherit',
        '& ~ .slider': {
          backgroundColor: theme.action_hover,
        },
        '& ~ .dot': {
          backgroundColor: theme.color_paper,
        },
      },
    },
    '& > .slider': {
      backgroundColor: theme.color_divider,
      height: '20px',
      width: '40px',
      borderRadius: '10px',
    },
    '& > .dot': {
      position: 'absolute',
      top: 2,
      left: 2,
      width: '16px',
      height: '16px',
      borderRadius: '8px',
      backgroundColor: theme.color_paper,
      transition: 'left 0.1s ease',
    },
  },
}));

/**
 * Switch component.
 */
export default function Switch({

  // Main props.
  id,
  className,
  fullWidth = false,
  size,

  // Input props.
  defaultChecked,
  checked,
  disabled,
  readOnly,
  autoFocus,

  // Input callbacks.
  onChange,
  onFocus,
  onBlur,

  children,
  ...rest

}) {


  const rootClass = 'Switch';

  const classes = useStyles();
  const cls = useMemo(() => cx(rootClass, classes.root, className), [rootClass, classes.root, className]);

  return (
    <div className={cls} {...rest}>
      <input
        id={id}
        type="checkbox"
        defaultChecked={defaultChecked}
        checked={checked}
        disabled={disabled}
        readOnly={readOnly}
        autoFocus={autoFocus}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <div className="slider" />
      <div className="dot" />
    </div>
  );
}
